import { useEffect } from "react";

/**
 * Set <title>, <meta name="description">, and <link rel="canonical"> per route.
 * Restores them on unmount to the defaults set in /public/index.html.
 */
const setOrUpdateMeta = (selector, attr, value) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("meta") ? "meta" : "link");
    if (selector.startsWith("meta")) {
      const name = selector.match(/name="([^"]+)"/)?.[1];
      if (name) el.setAttribute("name", name);
    } else if (selector.startsWith("link")) {
      const rel = selector.match(/rel="([^"]+)"/)?.[1];
      if (rel) el.setAttribute("rel", rel);
    }
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export default function useSeo({ title, description, canonical, robots }) {
  useEffect(() => {
    const prevTitle = document.title;
    const prevDesc =
      document.querySelector('meta[name="description"]')?.getAttribute("content");
    const prevCanonical =
      document.querySelector('link[rel="canonical"]')?.getAttribute("href");
    const prevRobots =
      document.querySelector('meta[name="robots"]')?.getAttribute("content");

    if (title) document.title = title;
    if (description) setOrUpdateMeta('meta[name="description"]', "content", description);
    if (canonical) setOrUpdateMeta('link[rel="canonical"]', "href", canonical);
    if (robots) setOrUpdateMeta('meta[name="robots"]', "content", robots);

    return () => {
      if (title && prevTitle) document.title = prevTitle;
      if (description && prevDesc)
        setOrUpdateMeta('meta[name="description"]', "content", prevDesc);
      if (canonical && prevCanonical)
        setOrUpdateMeta('link[rel="canonical"]', "href", prevCanonical);
      if (robots && prevRobots)
        setOrUpdateMeta('meta[name="robots"]', "content", prevRobots);
    };
  }, [title, description, canonical, robots]);
}
